import {
  Autocomplete,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import HeaderNavigation from "../../../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../../../Componants/Common/Button";
import DynamicTabs from "../../../../../components/DynamicTabs";
import {
  fetchServieCenterList,
  fetchBrandList,
  fetchStockInhandReport,
  getSparePartByModelDropdown,
  exportStockInHandReport,
} from "../../../../../API Service/apiService";
import toast, { Toaster } from "react-hot-toast";
import Paginate from "../../../../../Componants/Common/Paginate";
import Loader from "../../../../../Componants/Loader/Loader";
import ExportToExcel from "../../../../../Componants/Common/ExportToExcel";

const cells = [
  "Service Center",
  "Brand",
  "Type",
  "Part Code",
  "Part Name",
  "Stock QTY",
  "serialNumber"
];

const Stockinhand = () => {
  const [loading, setLoading] = useState(false);
  const [serviceCenterList, setServiceCenterList] = useState([]);
  const [organizationID, setOrganizationID] = useState("");
  const [brandList, setBrandList] = useState([]);
  const [partList, setPartList] = useState([]);
  const [selectedPart, setSelectedPart] = useState(null);

  const [page, setPage] = useState(1);
  const [dataSize, setDataSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableData, setTableData] = useState([]);

  const [searchParams, setSearchParams] = useState({
    serviceCenterId: "",
    partCode: "",
    brandId: "",
    page: 1,
    limit: 10,
  });

  // Fetch service center list
  const getServiceCenterList = async () => {
    try {
      setLoading(true);
      const response = await fetchServieCenterList(organizationID);
      if (response.status === "success") {
        setServiceCenterList(response.data.serviceCenters);
      }
    } catch (error) {
      console.log(`Error in fetching service center list`, error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch brand list
  const getBrandList = async () => {
    try {
      setLoading(true);
      const response = await fetchBrandList();
      if (response.data?.brandList) {
        setBrandList(response.data.brandList);
      }
    } catch (error) {
      console.error("Error fetching brand list:", error);
      toast.error("Failed to fetch brands");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    const updatedParams = { ...searchParams, page: newPage };
    setSearchParams(updatedParams);
    getStockInhandList(updatedParams);
  };

  const getStockInhandList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchStockInhandReport(params);
      if (response.status == 200) {
        setTableData(response.data.data.items);
        setTotalRecords(response.data.data.pagination.totalItems);
      }
    } catch (error) {
      console.error("Error fetching stock inhand list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPartDetailsData = async (brandId = "") => {
    try {
      const partResponse = await getSparePartByModelDropdown({ brandId });
      if (partResponse.status === "success") {
        setPartList(partResponse.data || []);
      } else {
        setPartList([]);
      }
    } catch (error) {
      console.error("Error fetching part details:", error);
      setPartList([]);
    }
  };

  const handleSearch = async () => {
    await getStockInhandList();
  };

  const handleExportToExcel = async () => {
    try {
      setLoading(true);
      const updatedParams = {
        ...searchParams,
        page: -1,
        limit: -1,
      };
      const response = await exportStockInHandReport(updatedParams);
      if (response?.status === "success" && response?.data?.filePath) {
        window.location.href = response.data.filePath;
        toast.success("File downloaded successfully");
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error exporting stock in hand report:", error);
      toast.error(error?.response?.data?.message || error.message || "Export failed");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async () => {
    const updatedParams = {
      serviceCenterId: "",
      partCode: "",
      brandId: "",
      page: 1,
      limit: 10,
    };
    setSearchParams(updatedParams);
    setSelectedPart(null);

    // Fetch the data after the state update
    await getStockInhandList(updatedParams);
  };

  useEffect(() => {
    getServiceCenterList();
    getBrandList();
    getStockInhandList();
  }, []);

  useEffect(() => {
    if(searchParams.brandId){
      fetchPartDetailsData(searchParams.brandId);
    }
  }, [searchParams.brandId]);

  return (
    <Grid container>
      {loading && <Loader />}
      <Toaster />
      <HeaderNavigation value={"Stock Report"} />
      <DynamicTabs />
      <Grid
        container
        gap={5}
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item>
          <Autocomplete
            id="service-center-dropdown"
            options={serviceCenterList}
            getOptionLabel={(option) => option.serviceCenter}
            value={
              serviceCenterList.find(
                (center) => center._id === searchParams.serviceCenterId
              ) || null
            }
            onChange={(e, newValue) => {
              setSearchParams((prevParams) => ({
                ...prevParams,
                serviceCenterId: newValue ? newValue._id : "",
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Service Center"
                variant="standard"
                style={{ width: "12rem" }}
              />
            )}
          />
        </Grid>
        <Grid item>
          <Autocomplete
            id="brand-dropdown"
            options={brandList}
            getOptionLabel={(option) => option.brandName || ""}
            value={
              brandList.find((brand) => brand._id === searchParams.brandId) ||
              null
            }
            onChange={(event, value) => {
              setSelectedPart(null);
              setSearchParams((prev) => ({
                ...prev,
                brandId: value ? value._id : "",
                partCode: "",
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Brand"
                variant="standard"
                style={{ width: "12rem" }}
              />
            )}
          />
        </Grid>
        <Grid item>
          <Autocomplete
            id="part-code-dropdown"
            options={partList}
            getOptionLabel={(option) => option.sparePartCode || ""}
            value={selectedPart}
            onChange={(event, value) => {
              setSelectedPart(value || null);
              setSearchParams((prev) => ({
                ...prev,
                partCode: value ? value.sparePartCode : "",
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Part Code"
                variant="standard"
                style={{ width: "12rem" }}
              />
            )}
          />
        </Grid>
        <Grid item>
          <Autocomplete
            id="part-name-dropdown"
            options={partList}
            getOptionLabel={(option) => option.sparePartName || ""}
            value={selectedPart}
            onChange={(event, value) => {
              setSelectedPart(value || null);
              setSearchParams((prev) => ({
                ...prev,
                partCode: value ? value.sparePartCode : "",
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Part Name"
                variant="standard"
                style={{ width: "12rem" }}
              />
            )}
          />
        </Grid>
        <Grid container gap={4}>
          <CommonButton name={"Search"} handleOnClick={handleSearch} />
          <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
        </Grid>
      </Grid>

      <Grid
        container
        gap={0}
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid
          container
          sx={{ width: "100%", display: "flex", justifyContent: "flex-end", mb: 0.5 }}
        >
          <ExportToExcel onClick={handleExportToExcel} />
        </Grid>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                {cells.map((cell, index) => (
                  <TableCell
                    key={index}
                    sx={{ color: "white", textAlign: "center" }}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">
                      {row.serviceCenterName}
                    </TableCell>
                    <TableCell align="center">{row.brandName}</TableCell>
                    <TableCell align="center">{row.type}</TableCell>
                    <TableCell align="center">{row.partCode}</TableCell>
                    <TableCell align="center">{row.partName}</TableCell>
                    <TableCell align="center">{row.stockQty}</TableCell>
                    <TableCell align="center">{row.serialNumber ? row.serialNumber : "NA"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={cells.length}
                    align="center"
                    sx={{ py: 3 }}
                  >
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Grid
          container
          sx={{
            marginTop: "1rem",
            marginBottom: "1rem",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Stockinhand;
